import { Pipe, PipeTransform } from "@angular/core";
import { orderBy } from 'lodash-es';

@Pipe({
    name: "orderBy",
    standalone: false
})
export class OrderByPipe implements PipeTransform {
 transform(array: any, sortBy: string, order?: boolean | "asc" | "desc"): any[] {
 const sortOrder: boolean | "asc" | "desc" = order ? order : 'asc'; // setting default ascending order

  return orderBy(array, [sortBy], [sortOrder]);
  }
}
